import DetailShipment from "./detail";

const routes = [
  {
    path: "/shipment/:id",
    component: DetailShipment,
  },
];

export default routes;
